import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip, IconButton, Typography, Button, Stack, Alert } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { Icon as Iconify } from '@iconify/react';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import useStateRef from 'react-usestateref';
import SchemeService from '../../../services/schemedefination.service';
import SlabModalPopUp from './SlabModalPopUp';
import { useSchemeStore } from '../schemeStore';
import { renderControls2 } from '../utils/renderControlsSlab';
import { renderControls } from '../utils/renderControls';








// --------------------------------------------------------------------------------------------------------
SchemSlabPopup.propTypes = {
    confirm: PropTypes.func,



};
// --------------------------------------------------------------------------------------------------------


export default function SchemSlabPopup(
    { confirm }) {
    const {
        schemeControls,
        schemeDetails,
        schemeSlabControls,
        slabPopupDiscountControls,
        slabPopupGiftControls,
        slabPopupFreeitemControls,
        setEditedSlabId,
        setSlabData,
        editSlabData,
        setEditSlabData,
        slabMainGridData,
        editedSlabId,
        schemeData,
        definitionData,
        thresholdSettings
    } = useSchemeStore();


    /*  ---------------------------- Alert Message -------------------------------------------------------   */

    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const [serviceInstance, setServiceInstance] = useState(null);

    useEffect(() => {

        const setInstance = async () => {

            const instance = await SchemeService;

            setServiceInstance(instance);

        };

        setInstance();

    }, []);


    const lifting = schemeControls.find(
        control => control.ValueExpr === "LiftingUnitOfMeasurement"
    )?.DefaultValues || [];

    const liftingName = lifting.find(
        item => String(item.LiftingUnitOfMeasurement) === String(schemeData?.LiftingUnitOfMeasurement)
    )?.LiftingUnitOfMeasurementName || "";



    const displayAlert = (type, message, show) => {
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }
    const hideAlert = () => {
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }

    /* --------------------------------------------------------------------------------------  */


    function generateUniqueId() {
        return `id-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`; // NOSONAR
    }


    function transformSlabData(data, type) {
        const discountTypeMap = {
            n: 'Net',
            p: 'Percentage',
            c: 'Rs'
        };

        const rewardObjs = data.Reward.filter(r => r.FilterType === type);

        if (rewardObjs.length === 0) return [];

        // Map each reward object to a transformed version
        return rewardObjs.map((rewardObj, index) => {
            const result = {
                SlabName: data.SlabName,
                LiftingQuantity: data.LiftingQuantity,
                ContributionQuantity: data.ContributionQuantity,
                AdditionalRebate: data.AdditionalRebate,
                PositiveThresholdLimit: data.PositiveThresholdLimit,
                NegativeThresholdLimit: data.NegativeThresholdLimit,
                Reward: rewardObj.FilterType,
                id: index,
            };

            if (rewardObj.FilterType === 'Discount') {
                result.DiscountType = {
                    DiscountType: rewardObj.DiscountType,
                    DiscountTypeExp: discountTypeMap[rewardObj.DiscountType] || 'Net'
                };
                result.DiscountRate = rewardObj.DiscountRate;
            } else if (rewardObj.FilterType === 'Gift') {
                result.GiftId = rewardObj.GiftId[0];
                result.GiftQty = rewardObj.GiftQty;
            } else if (rewardObj.FilterType === 'FreeItem') {
                result.ItemId = rewardObj.ItemId;
                result.FreeQty = rewardObj.FreeQty;
            }



            return result;
        });
    }





    useEffect(() => {
     //     console.log("editSlabData from popup", editSlabData);

        if (editSlabData != null) {
            setValue('SlabName', editSlabData?.SlabName);
            setValue('LiftingQuantity', editSlabData?.LiftingQuantity);
            if (editSlabData?.AdditionalRebate) {
                setValue('AdditionalRebate', editSlabData?.AdditionalRebate);
                setValue('ContributionQuantity', editSlabData?.ContributionQuantity);
            }
            if (editSlabData?.NegativeThresholdLimit) {
                setValue('NegativeThresholdLimit', editSlabData?.NegativeThresholdLimit);
                setValue('PositiveThresholdLimit', editSlabData?.PositiveThresholdLimit);
            }

            const discountData = transformSlabData(editSlabData, 'Discount');
            const giftData = transformSlabData(editSlabData, 'Gift');
            const freeItemData = transformSlabData(editSlabData, 'FreeItem');

      //      console.log("discountData: ", discountData);
      //      console.log("giftData: ", giftData);
     //       console.log("freeItemData: ", freeItemData);

            if (discountData) {
                setDiscountRows(prev => [...prev, ...discountData]);
            }
            if (giftData) {
                setGiftRows(prev => [...prev, ...giftData]);
            }
            if (freeItemData) {
                setFreeItemRows(prev => [...prev, ...freeItemData]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editSlabData]);
    const [discountRows, setDiscountRows] = useState([]);
    const [giftRows, setGiftRows] = useState([]);
    const [freeItemRows, setFreeItemRows] = useState([]);
    const [resett, setReset] = useState(0);

    const [discountRows2, setDiscountRows2, discountRows2Ref] = useStateRef([]);
    const [giftRows2, setGiftRows2, giftRows2Ref] = useStateRef([]);
    const [freeItemRows2, setFreeItemRows2, freeItemRows2Ref] = useStateRef([]);
    const [slabPresentMessage, setSlabPresentMessage] = useState('');





    const handleSave = () => {
        const slabDataMap = new Map();
        slabDataMap.set('discount', discountRows);
        slabDataMap.set('gift', giftRows);
        slabDataMap.set('freeItem', freeItemRows);
        setSlabData(slabDataMap);
        confirm(true);
    }


    const { control, handleSubmit, watch, setValue, reset } = useForm();
    const values = watch();

    useEffect(() => {
        //  console.log("valuesSlab: ", values);
    }, [values]);
    const handleCancel = () => {
        confirm(true);
        setEditSlabData(null);
        setEditedSlabId(null);
        reset();
        setDiscountRows([]);
        setGiftRows([]);
        setFreeItemRows([]);
    };

    function transformSlabsPopupData(slabPopupData) {
        const slabMap = new Map();

        // Iterate over each type (discount, gift, freeItem)
        // eslint-disable-next-line no-restricted-syntax
        for (const [type, rewards] of slabPopupData.entries()) {
            // eslint-disable-next-line no-restricted-syntax
            for (const reward of rewards) {
                const slabKey = reward.SlabName;
                // Check if slab already exists, else create
                if (!slabMap.has(slabKey)) {
                    slabMap.set(slabKey, {
                        id: generateUniqueId(), // or use reward.id if needed
                        SlabName: reward.SlabName,
                        LiftingQuantity: reward.LiftingQuantity,
                        ContributionQuantity: reward.ContributionQuantity,
                        AdditionalRebate: reward.AdditionalRebate,
                        Reward: []
                    });
                }
                // Prepare the reward object based on type
                let rewardObj = {};
                if (type === "discount") {
                    rewardObj = {
                        FilterType: "Discount",
                        DiscountType: reward.DiscountType.DiscountType,
                        // DiscountTypeExp: reward.DiscountType.DiscountTypeExp, // Add this line if needed
                        DiscountRate: reward.DiscountRate
                    };
                } else if (type === "gift") {
                    rewardObj = {
                        FilterType: "Gift",
                        GiftId: [reward.GiftId],
                        GiftQty: reward.GiftQty
                    };
                } else if (type === "freeItem") {
                    rewardObj = {
                        FilterType: "FreeItem",
                        ItemId: reward.ItemId,
                        FreeQty: reward.FreeQty
                    };
                }
                // Add to the Reward array
                slabMap.get(slabKey).Reward.push(rewardObj);
            }
        }

        // Return as array
        //  console.log("transformResult: ", Array.from(slabMap.values()));
        return Array.from(slabMap.values());
    }



    const updateNewRows = () => {

        //  console.log("slabMainGridData: ", slabMainGridData);
        const slabDataMap = new Map();
        slabDataMap.set('discount', discountRows2Ref.current);
        slabDataMap.set('gift', giftRows2Ref.current);
        slabDataMap.set('freeItem', freeItemRows2Ref.current);



        const updatedRows = transformSlabsPopupData(slabDataMap);
        if (editedSlabId == null) {
            return [...slabMainGridData, ...updatedRows];
            // eslint-disable-next-line no-else-return
        } else {

            const index = slabMainGridData.findIndex(row => row.Id === editedSlabId || row.id === editedSlabId);

            return [
                ...slabMainGridData.slice(0, index),
                ...updatedRows,
                ...slabMainGridData.slice(index + 1)
            ];
        };


    };

    function arraysEqualByKey(arr1, arr2, key = "ItemId") {
        if (arr1.length !== arr2.length) return false;
        const ids1 = arr1.map(it => it[key]).sort();
        const ids2 = arr2.map(it => it[key]).sort();
        return ids1.every((v, i) => v === ids2[i]);
    }

    function isDuplicateReward(newData, rows, rewardType) {
        if (rewardType === "Discount") {
            return rows.some(row =>
                row.id !== newData.id &&
                row.Reward === rewardType &&
                row.Reward === "Discount" &&
                row.DiscountType?.DiscountType === newData.DiscountType?.DiscountType &&
                row.DiscountRate === newData.DiscountRate
            );
        } if (rewardType === "Gift") {
            return rows.some(row =>
                row.id !== newData.id &&
                row.Reward === rewardType &&
                row.Reward === "Gift" &&
                row.GiftId?.GiftId === newData.GiftId?.GiftId &&
                row.GiftQty === newData.GiftQty
            );
        } if (rewardType === "FreeItem") {
            return rows.some(row =>
                row.id !== newData.id &&
                row.Reward === "FreeItem" &&
                arraysEqualByKey(row.ItemId, newData.ItemId) &&
                row.FreeQty === newData.FreeQty
            );
        }
        // Add similar logic for FreeItem
        return false;
    }




    const onSubmit = (data) => { // NOSONAR

        const newDataa = { ...data };

        if (values.Reward === "Discount" && isDuplicateReward(newDataa, discountRows, "Discount")) {
            displayAlert('warning', 'Discount reward already exists.', true);
            return;
        }
        if (values.Reward === "Gift" && isDuplicateReward(newDataa, giftRows, "Gift")) {
            displayAlert('warning', 'Gift reward already exists', true);
            return;
        }
        if (values.Reward === "FreeItem" && isDuplicateReward(newDataa, freeItemRows, "FreeItem")) {
            displayAlert('warning', 'FreeItem reward already exists.', true);
            return;
        }


        if (newDataa.id == null) { // NOSONAR
            newDataa.id = Date.now();
            //  console.log("!!! Assigned new id: ", newDataa.id);
        } else {
            //  console.log("!!! Existing id found: ", newDataa.id);
        }


        const updateArrays2 = (id, newReward) => {
            //  console.log("!!! updateArrays called with id:", id, "and newReward:", newReward);

            const isInDiscount = discountRows2?.find(row => row.id === id);
            //  console.log("!!! isInDiscount:", isInDiscount);

            const isInGift = giftRows2?.find(row => row.id === id);
            //  console.log("!!! isInGift:", isInGift);

            const isInFreeItem = freeItemRows2?.find(row => row.id === id);
            //  console.log("!!! isInFreeItem:", isInFreeItem);

            if (isInDiscount && newReward !== "Discount") {
                //  console.log("!!! Removing from discountRows, id:", id);
                setDiscountRows2(prev => prev.filter(row => row.id !== id));
            }
            if (isInGift && newReward !== "Gift") {
                //  console.log("!!! Removing from giftRows, id:", id);
                setGiftRows2(prev => prev.filter(row => row.id !== id));
            }
            if (isInFreeItem && newReward !== "FreeItem") {
                //  console.log("!!! Removing from freeItemRows, id:", id);
                setFreeItemRows2(prev => prev.filter(row => row.id !== id));
            }

            // Add to correct array (handles both adding new and updating existing):
            if (newReward === "Discount") {
                //  console.log("!!! Adding/updating in discountRows, id:", id);
                setDiscountRows2(prev => {
                    const existingIndex = prev.findIndex(row => row.id === id)
                    if (existingIndex > -1) {
                        //  console.log("!!! Updating existing entry in discountRows at index:", existingIndex);
                        const newRows = [...prev];
                        newRows[existingIndex] = newDataa
                        return newRows;
                    }
                    //  console.log("!!! Adding new entry to discountRows");
                    return [...prev, newDataa]
                });

            } else if (newReward === "Gift") {
                //  console.log("!!! Adding/updating in giftRows, id:", id);
                setGiftRows2(prev => {
                    const existingIndex = prev.findIndex(row => row.id === id)
                    if (existingIndex > -1) {
                        //  console.log("!!! Updating existing entry in giftRows at index:", existingIndex);
                        const newRows = [...prev];
                        newRows[existingIndex] = newDataa
                        return newRows;
                    }
                    //  console.log("!!! Adding new entry to giftRows");
                    return [...prev, newDataa]
                });
            } else if (newReward === "FreeItem") {
                //  console.log("!!! Adding/updating in freeItemRows, id:", id);
                setFreeItemRows2(prev => {
                    const existingIndex = prev.findIndex(row => row.id === id)
                    if (existingIndex > -1) {
                        //  console.log("!!! Updating existing entry in freeItemRows at index:", existingIndex);
                        const newRows = [...prev];
                        newRows[existingIndex] = newDataa
                        return newRows;
                    }
                    //  console.log("!!! Adding new entry to freeItemRows");
                    return [...prev, newDataa]
                });
            }
        };
        updateArrays2(newDataa.id, newDataa.Reward);
        const result = updateNewRows();
        setDiscountRows2([]);
        setGiftRows2([]);
        setFreeItemRows2([]);

        //  console.log("result", result);


        function hasDuplicateSlabNameOrLiftingQuantity(dataa) {
            const slabNames = new Set();
            const liftingQuantities = new Set();

            // eslint-disable-next-line no-restricted-syntax
            for (const item of dataa) {
                if (slabNames.has(item.SlabName) || liftingQuantities.has(item.LiftingQuantity)) {
                    return true;
                }
                slabNames.add(item.SlabName);
                liftingQuantities.add(item.LiftingQuantity);
            }

            return false;
        }



        const similarSlab = hasDuplicateSlabNameOrLiftingQuantity(result);

        if (similarSlab) {
            setSlabPresentMessage('Slab already exists.');
            return; // Prevent further processing
        } 
            setSlabPresentMessage('')
        



        //  console.log("!!! data on Submit: ", data);
        const newData = { ...data };

        if (newData.id == null) { // NOSONAR
            newData.id = Date.now();
            //  console.log("!!! Assigned new id: ", newData.id);
        } else {
            //  console.log("!!! Existing id found: ", newData.id);
        }

        const updateArrays = (id, newReward) => {
            //  console.log("!!! updateArrays called with id:", id, "and newReward:", newReward);

            const isInDiscount = discountRows?.find(row => row.id === id);
            //  console.log("!!! isInDiscount:", isInDiscount);

            const isInGift = giftRows?.find(row => row.id === id);
            //  console.log("!!! isInGift:", isInGift);

            const isInFreeItem = freeItemRows?.find(row => row.id === id);
            //  console.log("!!! isInFreeItem:", isInFreeItem);

            if (isInDiscount && newReward !== "Discount") {
                //  console.log("!!! Removing from discountRows, id:", id);
                setDiscountRows(prev => prev.filter(row => row.id !== id));
            }
            if (isInGift && newReward !== "Gift") {
                //  console.log("!!! Removing from giftRows, id:", id);
                setGiftRows(prev => prev.filter(row => row.id !== id));
            }
            if (isInFreeItem && newReward !== "FreeItem") {
                //  console.log("!!! Removing from freeItemRows, id:", id);
                setFreeItemRows(prev => prev.filter(row => row.id !== id));
            }

            // Add to correct array (handles both adding new and updating existing):
            if (newReward === "Discount") {
                //  console.log("!!! Adding/updating in discountRows, id:", id);
                setDiscountRows(prev => {
                    const existingIndex = prev.findIndex(row => row.id === id)
                    if (existingIndex > -1) {
                        //  console.log("!!! Updating existing entry in discountRows at index:", existingIndex);
                        const newRows = [...prev];
                        newRows[existingIndex] = newData
                        return newRows;
                    }
                    //  console.log("!!! Adding new entry to discountRows");
                    return [...prev, newData]
                });

            } else if (newReward === "Gift") {
                //  console.log("!!! Adding/updating in giftRows, id:", id);
                setGiftRows(prev => {
                    const existingIndex = prev.findIndex(row => row.id === id)
                    if (existingIndex > -1) {
                        //  console.log("!!! Updating existing entry in giftRows at index:", existingIndex);
                        const newRows = [...prev];
                        newRows[existingIndex] = newData
                        return newRows;
                    }
                    //  console.log("!!! Adding new entry to giftRows");
                    return [...prev, newData]
                });
            } else if (newReward === "FreeItem") {
                //  console.log("!!! Adding/updating in freeItemRows, id:", id);
                setFreeItemRows(prev => {
                    const existingIndex = prev.findIndex(row => row.id === id)
                    if (existingIndex > -1) {
                        //  console.log("!!! Updating existing entry in freeItemRows at index:", existingIndex);
                        const newRows = [...prev];
                        newRows[existingIndex] = newData
                        return newRows;
                    }
                    //  console.log("!!! Adding new entry to freeItemRows");
                    return [...prev, newData]
                });
            }
        };

        //  console.log("!!! Calling updateArrays with id:", newData.id, "and Reward:", newData.Reward);
        updateArrays(newData.id, newData.Reward);

        //  console.log("!!! Calling reset()");
        // reset();
        setValue('Reward', '');
        setValue('DiscountType', '');
        setValue('DiscountRate', '');
        setValue('GiftId', '');
        setValue('GiftQty', '');
        setValue('ItemId', []);
        setValue('FreeQty', '');
        setReset(prev => prev + 1);
    };




    const handleEdit = (row, rewardType) => {

        setValue("SlabName", row?.SlabName);
        setValue("LiftingQuantity", row?.LiftingQuantity);
        setValue("ContributionQuantity", row?.ContributionQuantity);
        setValue("AdditionalRebate", row?.AdditionalRebate);
        setValue("NegativeThresholdLimit", row?.NegativeThresholdLimit);
        setValue("PositiveThresholdLimit", row?.PositiveThresholdLimit);
        setValue("Reward", row?.Reward);
        setValue("id", row?.id);
        //  console.log("rewardType: ", rewardType);

        if (rewardType === "Discount") {
            //  console.log("1111")
            setValue("DiscountType", row?.DiscountType);
            setValue("DiscountRate", row?.DiscountRate);
        } else if (rewardType === "Gift") {
            //  console.log("2222")

            setValue("GiftQty", row?.GiftQty);
            setValue("GiftId", row?.GiftId);
        }
        else if (rewardType === "FreeItem") {
            //  console.log("3333")

            setValue("ItemId", row?.ItemId);
            setValue("FreeQty", row?.FreeQty);
        }
    };

    const handleDelete = (id, rewardType) => {
        if (rewardType === "Discount") {
            setDiscountRows(discountRows?.filter((row) => row.id !== id));
        } else if (rewardType === "Gift") {
            setGiftRows(giftRows?.filter((row) => row.id !== id));
        } else if (rewardType === "FreeItem") {
            setFreeItemRows(freeItemRows?.filter((row) => row.id !== id));
        }
    };

    const discountColumns = [

        { field: 'DiscountType', headerName: 'Discount Type', flex: 8, valueGetter: (params) => params.row.DiscountType?.DiscountTypeExp || '' },
        {
            field: 'DiscountRate', headerName: 'Discount Rate', flex: 5,
            align: 'right',
        },
        {
            field: 'edit',
            headerName: 'Edit',
            width: 80, // Set a fixed width for a smaller size
            renderCell: (params) => (
                <IconButton onClick={() => handleEdit(params.row, "Discount")}>
                    <Iconify icon="material-symbols:edit-outline" width="20" height="20" color="#1976d2" /> {/* Use Material UI's color prop */}
                </IconButton>
            ),
        },
        {
            field: 'delete',
            headerName: 'Delete',
            width: 80, // Set a fixed width for a smaller size  // Adjust flex as needed
            renderCell: (params) => (
                <IconButton onClick={() => handleDelete(params.id, "Discount")}>
                    <Iconify icon="fluent:delete-32-regular" width="20" height="20" color="red" /> {/* Use Material UI's color prop */}
                </IconButton>
            ),
        },
    ];


    const giftColumns = [
        { field: 'GiftId', headerName: 'Gift', flex: 8, valueGetter: (params) => params.row.GiftId?.Gift || '' }, // Add Gift column
        {
            field: 'GiftQty', headerName: 'Gift Quantity', flex: 5,
            align: 'right',
        }, // Add Gift Quantity column
        {
            field: 'edit',
            headerName: 'Edit',
            width: 80, // Adjust flex as needed
            renderCell: (params) => (
                <IconButton onClick={() => handleEdit(params.row, "Gift")}>
                    <Iconify icon="material-symbols:edit-outline" width="20" height="20" color="#1976d2" /> {/* Use Material UI's color prop */}
                </IconButton>
            ),
        },
        {
            field: 'delete',
            headerName: 'Delete',
            width: 80,  // Adjust flex as needed
            renderCell: (params) => (
                <IconButton onClick={() => handleDelete(params.id, "Gift")}>
                    <Iconify icon="fluent:delete-32-regular" width="20" height="20" color="red" /> {/* Use Material UI's color prop */}
                </IconButton>
            ),
        },
    ];

    const freeItemColumns = [
        {
            field: 'Item', headerName: 'Item', flex: 8, valueGetter: (params) => {
                if (params.row.ItemId && params.row.ItemId.length > 0) {
                    return params.row.ItemId.map(item => item.Item).join(', ') || '';
                }
                return '';
            }
        },
        { field: 'FreeQty', headerName: 'Item Quantity', flex: 5 }, // Add Item Quantity column
        {
            field: 'edit',
            headerName: 'Edit',
            width: 80, // Adjust flex as needed
            renderCell: (params) => (
                <IconButton onClick={() => handleEdit(params.row, "FreeItem")}>
                    <Iconify icon="material-symbols:edit-outline" width="20" height="20" color="#1976d2" /> {/* Use Material UI's color prop */}
                </IconButton>
            ),
        },
        {
            field: 'delete',
            headerName: 'Delete',
            width: 80,  // Adjust flex as needed
            renderCell: (params) => (
                <IconButton onClick={() => handleDelete(params.id, "FreeItem")}>
                    <Iconify icon="fluent:delete-32-regular" width="20" height="20" color="red" /> {/* Use Material UI's color prop */}
                </IconButton>
            ),
        }
    ];


    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.columnHeader}`]: {
            backgroundColor: 'white',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '13px',
            height: '40px',  // Reduce header height
            lineHeight: '40px',  // Adjust line height to match
            paddingLeft: '4px', // Remove left padding

        },

        '& .MuiDataGrid-cell': {
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
            fontSize: '13px', // Adjust font size if needed
            padding: '4px 8px 4px 4px', // Adjust cell padding to reduce row height
            '&:hover': {
                backgroundColor: 'white',
            },
        },

        '& .MuiDataGrid-row': {
            minHeight: '40px',  // Reduce row height
            maxHeight: '40px',  // Keep row height consistent
            '&:hover': {
                backgroundColor: 'white',
            },
        },

        '& .MuiDataGrid-columnSeparator': {
            display: 'none',
        },

        '& .MuiDataGrid-menuIcon': {
            display: 'none',
        },
        // Align first column cells to the right
        '& .MuiDataGrid-cell.SchemeFilterOn': {
            textAlign: 'left',
            paddingLeft: '0px', // Remove left padding for second column
        },
        '& .MuiDataGrid-cell.Filter': {
            textAlign: 'left',
            paddingLeft: '0px', // Remove left padding for third column
        },
        '& .MuiDataGrid-cell.FilterSubClassification': {
            textAlign: 'left',
            paddingLeft: '0px', // Remove left padding for fourth column
        },

    }));

    // Find the value from thresholdSettings
    const thresholdSetting = thresholdSettings?.find(
        (item) => item.Key === "ExceptionThresholdPositiveNegativeApplicable"
    );

    // Check if the setting is true
    const isPositiveNegativeApplicable = thresholdSetting?.Value === "false";  
   

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, }}>
            <FormProvider>
                <SlabModalPopUp cancel={handleCancel} title='Scheme Slab'  >
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', display: 'flex', flexDirection: 'column', minHeight: 0, flexGrow: 1 }}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            minHeight: 0,
                            // overflow: 'auto',

                            '&::-webkit-scrollbar': {
                                width: '6px', // Set the width of the scrollbar
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#888', // Color of the scrollbar thumb
                                borderRadius: '10px', // Rounded corners for the scrollbar thumb
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: '#555', // Color when hovered
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1', // Color of the scrollbar track
                            },


                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 6,
                                    minHeight: 0,
                                }}
                            >
                                <Typography variant='subtitle2' sx={{ color: 'gray' }}>
                                    Free Quantity Unit Of Measurement : {liftingName}
                                </Typography>
                                <Box
                                    rowGap={1}
                                    columnGap={1}
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: '1fr',
                                        sm: '1fr 1fr',
                                        md: '1fr 1fr',
                                        lg: '1fr 1fr 1fr',
                                        xl: '1fr 1fr 1fr'
                                    }}
                                    sx={{ my: 2, maxHeight: '165px' }} >
                                    {schemeSlabControls &&
                                        schemeSlabControls.map((field, index) => {
                                            // Hide Negative/PositiveThresholdLimit if ThresholdPercentage is null or undefined
                                            if (
                                                (isPositiveNegativeApplicable) &&
                                                ['NegativeThresholdLimit', 'PositiveThresholdLimit'].includes(field.ValueExpr)
                                            ) {
                                                return null;
                                            }

                                            // Hide AdditionalRebate control if SchemeData.AdditionalRebate is not true
                                            if (
                                                (field.ValueExpr === 'AdditionalRebate' || field.ValueExpr === 'ContributionQuantity') &&
                                                !schemeData?.AdditionalRebate
                                            ) {
                                                return null;
                                            }

                                            // Otherwise, render the control
                                            return renderControls(field, index, control, null, resett, values);
                                        })
                                    }
                                    {values?.Reward === "Discount" && slabPopupDiscountControls && slabPopupDiscountControls.map((field, index) => isPositiveNegativeApplicable  && ['NegativeThresholdLimit', 'PositiveThresholdLimit'].includes(field.ValueExpr) ? null : renderControls2(field, index, control, null, resett, values))}
                                    {values?.Reward === "Gift" && slabPopupGiftControls && slabPopupGiftControls.map((field, index) => isPositiveNegativeApplicable && ['NegativeThresholdLimit', 'PositiveThresholdLimit'].includes(field.ValueExpr) ? null : renderControls2(field, index, control, null, resett, values))}
                                    {values?.Reward === "FreeItem" && slabPopupFreeitemControls && slabPopupFreeitemControls.map((field, index) => isPositiveNegativeApplicable  && ['NegativeThresholdLimit', 'PositiveThresholdLimit'].includes(field.ValueExpr) ? null : renderControls2(field, index, control, serviceInstance.SearchFilter, resett, values))}

                                </Box>
                            </Box>

                            <Box sx={{ py: 0.5, px: 0.5, }}>
                                <Stack
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    spacing={1}

                                >
                                    <Typography variant="body2" sx={{ color: 'red' }}>
                                        {slabPresentMessage}
                                    </Typography>
                                    <Tooltip title="Add" arrow>
                                        <Button type='submit'
                                            variant='contained'
                                            sx={{
                                                height: '30px',
                                                width: '31px',
                                                bgcolor: '#1badd1',
                                                borderRadius: '4px',
                                                minWidth: 'auto',
                                                fontSize: '25px',
                                                '&:hover': {
                                                    bgcolor: '#1badd1',
                                                },
                                            }}
                                        >
                                            +
                                        </Button>
                                    </Tooltip>

                                </Stack>
                            </Box>
                            {discountRows?.length > 0 && (
                                <Box sx={{ width: '100%', mb: 1 }}>
                                    <StripedDataGrid
                                        sx={{
                                            height: 90,
                                            '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                            '& .MuiDataGrid-footerContainer': {
                                                borderTop: 'none', // Remove top border
                                            },
                                        }}
                                        rowHeight={30}
                                        headerHeight={30}
                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even'
                                        }
                                        components={{ Pagination: null }}
                                        hideFooterPagination
                                        disableSelectionOnClick
                                        rows={discountRows}
                                        columns={discountColumns}
                                        getRowId={(row) => row?.id}
                                    />
                                </Box>
                            )}

                            {giftRows?.length > 0 && (
                                <Box sx={{ width: '100%', mb: 1 }}>
                                    <StripedDataGrid
                                        sx={{
                                            height: 90,
                                            '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                            '& .MuiDataGrid-footerContainer': {
                                                borderTop: 'none', // Remove top border
                                            },
                                        }}
                                        rowHeight={30}
                                        headerHeight={30}
                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even'
                                        }
                                        components={{ Pagination: null }}
                                        hideFooterPagination
                                        disableSelectionOnClick
                                        rows={giftRows}
                                        columns={giftColumns}
                                        getRowId={(row) => row?.id}
                                    />
                                </Box>
                            )}

                            {freeItemRows?.length > 0 && (
                                <Box sx={{ width: '100%' }}>
                                    <StripedDataGrid
                                        sx={{
                                            height: 90,
                                            '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                            '& .MuiDataGrid-footerContainer': {
                                                borderTop: 'none', // Remove top border
                                            },
                                        }}
                                        rowHeight={30}
                                        headerHeight={30}
                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even'
                                        }
                                        components={{ Pagination: null }}
                                        hideFooterPagination
                                        disableSelectionOnClick
                                        rows={freeItemRows}
                                        columns={freeItemColumns}
                                        getRowId={(row) => row?.id}
                                    />
                                </Box>
                            )}

                        </Box>
                        <Box sx={{ py: 0.5, px: 0.5 }}>
                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"

                            >
                                <Tooltip title="Save" onClick={handleSave} sx={{ bgcolor: '#43b5a2', color: '#fff', borderRadius: '4px', height: '30px', width: '31px', padding: '4px', marginLeft: '0px' }}>
                                    <IconButton type="button" size='small'>
                                        <Iconify icon="bx:save" />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </Box>

                    </form>
                    {showAlert && (
                        <Stack sx={{ height: '2em', width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                            <Alert
                                severity={alertType}
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={hideAlert}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                            >
                                {alertMessage}
                            </Alert>
                        </Stack>
                    )}
                </SlabModalPopUp>

            </FormProvider>

        </Box>
    )
}

